module.exports = __webpack_public_path__ + "img/9cd3c97.png";